import { environment } from '@lla-platform/core/core-util'

export const RECEIVABLE_API_URL = {
  // Receivables
  base: (receivableId: string) => `${environment.apiUrl}/receivables/${receivableId}`,
  detailedList: `${environment.apiUrl}/receivables/filters`,
  exportReceivablesList: `${environment.apiUrl}/receivables/filters/export`,
  receivablesSummaryByShop: `${environment.apiUrl}/receivables/summary/location`,
  exportReceivablesSummaryByShop: `${environment.apiUrl}/receivables/summary/location/export`,
  receivablesSummaryByAccount: `${environment.apiUrl}/receivables/summary/accountName`,
  exportReceivablesSummaryByAccount: `${environment.apiUrl}/receivables/summary/accountName/export`,
  arInvoicesSummary: `${environment.apiUrl}/receivables/summary/ar`,
  exportArInvoicesSummary: `${environment.apiUrl}/receivables/summary/ar/export`,

  // Invoices
  invoicesListOverview: `${environment.apiUrl}/invoices/filters/overview`,
  arInvoicesList: `${environment.apiUrl}/invoices/filters`,
  exportArInvoicesList: `${environment.apiUrl}/invoices/filters/export`,
  invoicesGeoLocations: `${environment.apiUrl}/invoices/filters/geo-location`,
  getInvoice: (invoiceId: string) => `${environment.apiUrl}/invoices/${invoiceId}`,

  // Invoices Category Overview
  categoryOverview: `${environment.apiUrl}/invoices/category-overview`,

  // Invoices GP
  getGrossProfit: `${environment.apiUrl}/invoices/invoice-gp`,
  exportGrossProfit: `${environment.apiUrl}/invoices/invoice-gp/export`,
  grossProfitList: `${environment.apiUrl}/invoices/filters/invoice-gp`,
  exportGrossProfitList: `${environment.apiUrl}/invoices/filters/export/invoice-gp`,

  // Invoices GP Packages
  getGpPackage: `${environment.apiUrl}/invoicepackages/gp`,
  exportGpPackage: `${environment.apiUrl}/invoicepackages/gp/export`,
  gpPackageList: `${environment.apiUrl}/invoicepackages/filters/gp`,
  exportGpPackageList: `${environment.apiUrl}/invoicepackages/filters/export/gp`,
  getPackageUnperformed: `${environment.apiUrl}/invoicepackages/unperformed`,
  exportPackageUnperformed: `${environment.apiUrl}/invoicepackages/unperformed/export`,

  // Invoices Package Lines
  invoicePackageLinesList: `${environment.apiUrl}/invoicepackagelines/filters`,
  exportInvoicePackageLinesList: `${environment.apiUrl}/invoicepackagelines/filters/export`,

  // Invoice Lines report
  invoiceLinesList: `${environment.apiUrl}/invoicelines/filters`,
  invoiceLinesOverview: `${environment.apiUrl}/invoicelines/filters/overview`,
  invoiceLinesPriceAdherence: `${environment.apiUrl}/invoicelines/filters/price-adherence`,

  // AR Payment
  arPaymentsSummary: `${environment.apiUrl}/receivables/summary/ar-payments`,
  exportArPaymentsSummary: `${environment.apiUrl}/receivables/summary/ar-payments/export`,

  // Snapshots
  receivableSnapshot: `${environment.apiUrl}/receivables/snapshots`,
  exportReceivableSnapshot: `${environment.apiUrl}/receivables/snapshots/export`
}
